// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Tabs_buttons__1MtCW","button":"Tabs_button__1Kklg","active":"Tabs_active__2hPHG"};